import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'gold' | 'forest';
  size?: 'md' | 'lg';
};
const variants = {
  gold: 'bg-gold text-charcoal border-b-4 border-gold-dark shadow-lg shadow-gold/30 hover:bg-gold-light focus:ring-gold/50',
  forest: 'bg-forest text-ivory border-b-4 border-forest-dark shadow-lg shadow-forest/30 hover:bg-forest-dark focus:ring-forest/40'
};
const sizes = {
  md: 'px-6 py-3.5 text-sm md:text-base',
  lg: 'px-6 py-4 text-base md:px-10 md:py-5 md:text-xl'
};
export function Button({
  children,
  href,
  subtext,
  className = '',
  fullWidth,
  variant = 'gold',
  size = 'md'
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex flex-col items-center justify-center rounded-xl text-center font-display font-black uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus:ring-4 ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-244" data-mp="35wd85ccy19z">
      <span className="flex items-center gap-2" data-id="element-245" data-mp="12n3eb5en97cy">
        {children}
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-246" data-mp="12l8slovjtb7t" />
      </span>
      {subtext && <span className="mt-1 font-sans text-[11px] font-semibold normal-case tracking-normal opacity-80 md:text-xs" data-id="element-247" data-mp="1cdev3sjffb19">
          {subtext}
        </span>}
    </motion.a>;
}